import React, { Component } from 'react';
import './Footer.css';
import {Header, Divider} from 'semantic-ui-react'

class Footer extends Component {
  render() {
    return (
        <div className="footer">
          <Divider />
          <Header><a href="mailto:tanner@tlgraham.com"> Contact Me </a></Header>
          <Divider hidden />
        </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer/Footer.js